import React, { useEffect, useContext } from 'react';

import ResultsComponent from '../../../../components/ResultsComponent';

import { LiquidContext } from '../../../../contexts/LiquidProvider';
import { CalculatorNavigationContext } from '../../../../contexts/CalculatorNavigationProvider';
import { ResultsContext } from '../../../../contexts/ResultsProvider';

function LiquidDraperResultScreen(): React.ReactElement {
 const {
  setNextButtonAction,
  setNextButtonText,
  setBackButtonText,
  setBackButtonAction,
 } = useContext(CalculatorNavigationContext);

 const { fourthScreenRedirect, homeRedirect } = useContext(LiquidContext);

 const { setHasMultipleResults } = useContext(ResultsContext);

 const setNavigationProps = () => {
  const setNextButtonProps = () => {
   setNextButtonAction(homeRedirect); // fix
   setNextButtonText('Ferdig');
  };
  const setBackButtonProps = () => {
   setBackButtonText('Forrige');
   setBackButtonAction(fourthScreenRedirect);
  };
  setNextButtonProps();
  setBackButtonProps();
 };

 useEffect(() => {
  setNavigationProps();
  setHasMultipleResults(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 return <ResultsComponent />;
}

export default LiquidDraperResultScreen;
